import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKubernetesComponent } from './simple-icons-kubernetes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKubernetesComponent ],
    exports:      [ SimpleIconsKubernetesComponent ],
    bootstrap:    []
})
export class SimpleIconsKubernetesModule {}
